<div id="bonusActionDetail" class="bonusdetail-detail-container ya-typography">
  <ya-subheader [hasContent]="false"></ya-subheader>
  <div class="ya-page-content ya-page-content--webshop" (swipeleft)="swipeLeftHandler()">
    <ng-container *ngIf="hasData; then pageTemplate else emptyTemplate"></ng-container>
    <ng-template #pageTemplate>
      <div class="bonus-detail-image-wrapper">
        <div class="aspect-ratio-box">
          <div class="aspect-ratio-box-inside">
            <div class="aspect-ration-img-box">
              <img class="ya_image" [src]="bonusactionDetailViewModel.image_photo" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="bonus-detail-wrapper">
        <section class="bonus-detail-content">
          <div class="bonus-detail-page-content-header ya-detail-page-header">
            <div id="headerTitleContainer" class="ya-page-content-header">
              <h2 id="headerTitle">{{bonusactionDetailViewModel.labelDE}}</h2>
            </div>
            <div class="bonus-detail-like">
              <ya-favoritebutton [likeStatus]="bonusactionDetailViewModel.like" [contentType]="contentType.Bonussystem"
                [likeStatus]="bonusactionDetailViewModel.like" [modelId]="bonusactionDetailViewModel.id">
              </ya-favoritebutton>
            </div>
          </div>
          <p [innerHTML]="bonusactionDetailViewModel.description"> </p>
          <div class="actions">
            <div class="bonus-detail-ranking-bar">
              <bar-rating [(rate)]="bonusactionDetailViewModel.rate" [max]="5" [readOnly]="true"
                [theme]="'fontawesome-o'"></bar-rating>
              <div class="rate-click-div" (click)="openRateModel(bonusactionDetailViewModel)"></div>
            </div>
          </div>
          <div class="bonus-detail-date-container">
            <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-events"></div>
            <div class="container bonus-detail-date-wrapper">
              <div class="container-border">
                <div class="bonus-detail-date top">
                  <span class="description" langkey="phEventDetail_From"></span>
                  <span>
                    {{bonusactionDetailViewModel.startDateYMD}}
                  </span>
                </div>
              </div>
              <ng-container *ngIf="bonusactionDetailViewModel.hasEnd">

                <div class="bonus-detail-date bottom">
                  <span class="description" langkey="phEventDetail_To"></span>
                  <span>
                    {{bonusactionDetailViewModel.endDateYMD}}
                  </span>
                </div>
              </ng-container>
            </div>
            <ng-container *ngIf="showBonusLocation()">
              <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-standort"></div>
              <mat-expansion-panel class="container bonus-detail-location-wrapper" (opened)="locationPanel()"
                (closed)="locationPanel()">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <span class="description" langkey="phBonusActionDetails_Location"></span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="location-list-container">
                  <ng-container *ngFor="let bonusLocation of bonusactionDetailViewModel.locations">
                    <span>
                      {{bonusLocation.label}}
                    </span>
                  </ng-container>
                </div>
              </mat-expansion-panel>
            </ng-container>
          </div>
          <div class="bonus-detail-content-header ya-detail-page-header">
            <div id="headerTitleContainer" class="bonus-detail-title">
              <h2 langkey="phBonusAction_Benefits"></h2>
            </div>
            <ng-container *ngIf="bonusactionDetailViewModel.hasValidPoints">
              <div class="total-points">
                <span langkey="phBonusAction_Current_Points"></span>
                <span>{{bonusactionDetailViewModel.points}}</span>
              </div>
            </ng-container>
          </div>
          <ng-container *ngIf="bonusactionDetailViewModel.hasPointsLoadingError">
            <span langkey="phBonusAction_Load_Points_Error"></span>
          </ng-container>
          <ng-container *ngIf="showPointsInBasketLabel(bonusactionDetailViewModel.pointsInBasket)">
            <div class="bonus-redeem--info">
              <span
                [innerHTML]="pointsInBasketLabel(bonusactionDetailViewModel.points,bonusactionDetailViewModel.pointsInBasket)"></span>
            </div>
          </ng-container>
          <div class="item-column-container" [class.custom-space]="bonusactionDetailViewModel.hasPointsLoadingError">
            <ng-container *ngFor="let benefit of bonusactionDetailViewModel.benefits">
              <div class="item-column-container__item">
                <div class="ya-content-item bonus-item">
                  <div a11y_Button class="articleCard articleCard--has-image"
                    (click)="handleBenefitRedemption(benefit, bonusactionDetailViewModel)">
                    <div class="image-container">
                      <div class="aspect-ratio-box">
                        <div class="aspect-ratio-box-inside">
                          <div class="aspect-ration-img-box">
                            <img class="ya_image" [src]="benefit.image_photo" alt="" />
                          </div>
                        </div>
                      </div>
                      <div class="benefit-cost">
                        <span>{{createBonusActionPointsText(benefit.cost)}}</span>
                      </div>
                    </div>
                    <div class="content-container">
                      <div class="product-label-content">
                        <div>
                          <h3>
                            {{benefit.label_de}}
                          </h3>
                        </div>
                      </div>
                      <div class="content-lower-bar">
                        <ng-container *ngIf="!benefit.isInBasket; then Default else BenefitInBasket"> </ng-container>
                        <ng-template #Default>
                          <ng-container
                            *ngIf="benefit.benefitpercantage >= fullpercent; then redeemTemplate else collectTemplate"></ng-container>
                          <ng-template #collectTemplate>
                            <div class="point-circle counting">
                              <div class="inline-icon hyp-filter-svg" inlineSVG="shop-icons.svg#ya-hypersoft-bonus">
                              </div>
                              <svg viewBox="0 0 46 46" class="circular-chart points">
                                <path class="circle-bg" d="M23 7.0845
                                  a 15.9155 15.9155 0 0 1 0 31.831
                                  a 15.9155 15.9155 0 0 1 0 -31.831" />
                                <path class="circle" style.stroke-dasharray="{{benefit.benefitpercantage}}, 100" d="M23 7.0845
                                  a 15.9155 15.9155 0 0 1 0 31.831
                                  a 15.9155 15.9155 0 0 1 0 -31.831" />
                              </svg>
                            </div>
                          </ng-template>
                          <ng-template #redeemTemplate>
                            <span class="circle-text" langkey="phBonusAction_Redeem_Benefits"></span>
                            <div class="point-circle redeem-circle">
                              <div class="inline-icon hyp-filter-svg" inlineSVG="shop-icons.svg#ya-hypersoft-bonus">
                              </div>
                              <svg viewBox="0 0 46 46" class="circular-chart points">
                                <path class="circle-bg" d="M23 7.0845
                                  a 15.9155 15.9155 0 0 1 0 31.831
                                  a 15.9155 15.9155 0 0 1 0 -31.831" />
                                <path class="circle-line" d="M23 7.0845
                                  a 15.9155 15.9155 0 0 1 0 31.831
                                  a 15.9155 15.9155 0 0 1 0 -31.831" />
                                <path class="circle" stroke-dasharray="100, 100" d="M23 7.0845
                                  a 15.9155 15.9155 0 0 1 0 31.831
                                  a 15.9155 15.9155 0 0 1 0 -31.831" />
                              </svg>
                            </div>
                          </ng-template>
                        </ng-template>
                        <ng-template #BenefitInBasket>
                          <ng-container
                            *ngIf="canRedeemAgain(benefit.cost), then redeemTemplate else collectTemplate"></ng-container>
                          <ng-template #collectTemplate>
                            <div class="point-circle counting">
                              <div class="inline-icon hyp-filter-svg" inlineSVG="hypersoft-bonus.svg"></div>
                              <svg viewBox="0 0 46 46" class="circular-chart points">
                                <path class="circle-bg" d="M23 7.0845
                                  a 15.9155 15.9155 0 0 1 0 31.831
                                  a 15.9155 15.9155 0 0 1 0 -31.831" />
                                <path class="circle"
                                  style.stroke-dasharray="{{BenefitInBasketPercentage(benefit.cost)}}, 100" d="M23 7.0845
                                  a 15.9155 15.9155 0 0 1 0 31.831
                                  a 15.9155 15.9155 0 0 1 0 -31.831" />
                              </svg>
                            </div>
                          </ng-template>
                          <ng-template #redeemTemplate>
                            <span class="circle-text" langkey="phBonusAction_Redeem_Benefits"></span>
                            <div class="point-circle redeem-circle">
                              <div class="inline-icon hyp-filter-svg" inlineSVG="hypersoft-bonus.svg"></div>
                              <svg viewBox="0 0 46 46" class="circular-chart points">
                                <path class="circle-bg" d="M23 7.0845
                                  a 15.9155 15.9155 0 0 1 0 31.831
                                  a 15.9155 15.9155 0 0 1 0 -31.831" />
                                <path class="circle-line" d="M23 7.0845
                                  a 15.9155 15.9155 0 0 1 0 31.831
                                  a 15.9155 15.9155 0 0 1 0 -31.831" />
                                <path class="circle" stroke-dasharray="100, 100" d="M23 7.0845
                                  a 15.9155 15.9155 0 0 1 0 31.831
                                  a 15.9155 15.9155 0 0 1 0 -31.831" />
                              </svg>
                            </div>
                          </ng-template>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </section>
      </div>
    </ng-template>
    <ng-template #emptyTemplate>
      <ya-emptypage></ya-emptypage>
    </ng-template>
  </div>
</div>